export default "https://cdn.questicon.mathletics.com/assets/audio/beforeCollectingCoins-8f4234742989b4756da0330598c44e49.mp3";